/**
 * Meta Pixel tracking utility
 * Wraps fbq() calls with TypeScript safety
 */

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
}

export function trackCustomEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }
}

// Standard events
export const MetaPixel = {
  /** Track page view (auto-fired by base code) */
  pageView: () => trackEvent('PageView'),

  /** Track when someone reaches the /join page (potential lead) */
  lead: (params?: { leadId?: string; source?: string }) =>
    trackEvent('Lead', params),

  /** Track app download click */
  initiateCheckout: (params?: { source?: string }) =>
    trackEvent('InitiateCheckout', params),

  /** Track SP registration complete */
  completeRegistration: (params?: { method?: string }) =>
    trackEvent('CompleteRegistration', params),

  /** Track landing page engagement */
  viewContent: (params?: { content_name?: string; content_category?: string }) =>
    trackEvent('ViewContent', params),

  /** Custom: Track Play Store click from /join page */
  playStoreClick: (params?: { source?: string; leadId?: string }) =>
    trackCustomEvent('PlayStoreClick', params),

  /** Track "Download App" CTA clicks on the landing page */
  downloadAppClick: (params?: { source?: string }) =>
    trackCustomEvent('DownloadAppClick', params),

  /**
   * Custom: Track SP registration intent (high-value event for ad targeting).
   * Fired when a visitor clicks "Register as Provider" or "Become a Partner".
   */
  spRegistrationIntent: (params?: { source?: string }) =>
    trackCustomEvent('SPRegistrationIntent', params),

  /** Track contact email link clicks */
  contactEmailClick: () =>
    trackCustomEvent('ContactEmailClick'),
};
